import type {ReactNode} from 'react';
import styles from './Onboarding.module.css';

interface OnboardingLayoutProps {
  currentStep: number;
  totalSteps: number;
  children: ReactNode;
}

export function OnboardingLayout({currentStep, totalSteps, children}: OnboardingLayoutProps) {
  return (
    <div className={styles.overlay}>
      <div className={styles.inner}>
        <div className={styles.logo}>Closai</div>
        <div className={styles.tagline}>All your purchases in one place.</div>

        <div className={styles.dots}>
          {Array.from({length: totalSteps}, (_, i) => (
            <span
              key={i}
              className={[styles.dot, i + 1 === currentStep ? styles.dotActive : '']
                .filter(Boolean)
                .join(' ')}
            />
          ))}
        </div>

        <div className={styles.stepContent}>{children}</div>
      </div>
    </div>
  );
}
